import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {yup} from "./index";


export const useIncidentSchema = () => {
    const {t} = useTranslation('validation');

    const number = yup.number().emptyToNull().typeError(t('validation:number'))
    const positiveNumber = number.min(0, t('validation:gte', {gte: 0}));
    const positiveInteger = number.integer(t('validation:integer')).min(0, t('validation:gte', {gte: 0}))

    return useMemo(
        () => (
            yup.object().shape({
                date: yup.date().required(t('validation:required')),
                timeRange: yup.string().required(t('validation:required')),
                datetime: yup.date().nullable(),
                workgroupId: yup.number().required(t('validation:required')),
                regionId: yup.number().required(t('validation:required')),
                provinceId: yup.number().required(t('validation:required')),
                municipalityId: yup.number().required(t('validation:required')),
                locationName: yup.string().nullable(),
                elevationRelease: positiveInteger,
                aspect: yup.string().required(t('validation:required')),
                geom: yup.object().shape({
                    coordinates: yup.array().of(
                        positiveNumber.required(t('validation:required'))
                    ),
                }),
                // Conditions
                snowHeightMin: positiveInteger,
                snowHeightMax: positiveInteger,
                slopeAngleReleaseRange: yup.string().required(t('validation:required')),
                slopeAngleRelease: positiveInteger,
                avalancheType: yup.string().required(t('validation:required')),
                avalancheSize: yup.string().required(t('validation:required')),
                ww: yup.string().required(t('validation:required')),
                daysSinceLastSnowfall: positiveInteger,
                nearRidge: yup.string().required(t('validation:required')),
                dangerScaleBulletin: yup.string().required(t('validation:required')),
                tap1Bulletin: yup.string().required(t('validation:required')),
                tap2Bulletin: yup.string().required(t('validation:required')),
                tap1Incident: yup.string().required(t('validation:required')),
                tap2Incident: yup.string().required(t('validation:required')),

                // Incident
                alpineRescue: yup.string().required(t('validation:required')),
                incidentCategory: yup.string().required(t('validation:required')),
                // subcategory required if category is not 10 (motoslitta) or 8 (altro)
                incidentSubcategory: yup.string().when('incidentCategory', {
                    is: (val) => val !== '10' && val !== '8',
                    then: () => yup.string().required(t('validation:required')),
                    otherwise: () => yup.string().nullable(),
                }),
                groupWithProfessionalGuide: yup.boolean().required(t('validation:required')),
                numberOfPeopleInvolved: positiveInteger.required(t('validation:required')),
                notes: yup.string().nullable(),
            }))
        ,
        [t]
    )
}